import React from 'react'


const UserIcon = ({ active }) => {
    return (
        <svg className={`svg-icon ${active}`} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
            viewBox="20 10 25 30" >

            <path className="color" d="M37.9,17.8c-0.1,0-0.2,0-0.2-0.1c-1.9-1-3.6-1.4-5.6-1.4c-2,0-3.9,0.5-5.6,1.4c-0.2,0.1-0.5,0-0.7-0.2
                c-0.1-0.2,0-0.5,0.2-0.7c1.9-1,3.9-1.5,6-1.5c2.1,0,4,0.5,6,1.5c0.2,0.1,0.3,0.4,0.2,0.7C38.3,17.6,38.1,17.7,37.9,17.8z M23.6,23
                c-0.3,0-0.5-0.2-0.5-0.5c0-0.1,0-0.2,0.1-0.3c1-1.4,2.2-2.5,3.8-3.3c3.1-1.6,7.2-1.6,10.3,0c1.5,0.8,2.8,1.9,3.8,3.2
                c0.2,0.2,0.1,0.5-0.1,0.7c0,0,0,0,0,0c-0.2,0.2-0.5,0.1-0.7-0.1c0,0,0,0,0,0c-0.9-1.2-2-2.2-3.4-2.9c-2.9-1.5-6.5-1.5-9.4,0
                c-1.4,0.7-2.5,1.7-3.4,3C23.9,22.9,23.7,23,23.6,23z M29.8,35.1c-0.1,0-0.3-0.1-0.4-0.2c-0.9-0.9-1.3-1.4-2-2.6
                c-0.7-1.2-1-2.7-1-4.3c0-3,2.5-5.4,5.7-5.4c3.1,0,5.7,2.4,5.7,5.4c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5
                c0-2.4-2.1-4.4-4.7-4.4s-4.7,2-4.7,4.4c0,1.4,0.3,2.8,0.9,3.9c0.6,1.1,1.1,1.6,1.9,2.4c0.2,0.2,0.2,0.5,0,0.7
                C30.1,35,30,35.1,29.8,35.1z M37,33.2c-1.2,0-2.2-0.3-3.1-0.9c-1.5-1-2.4-2.6-2.4-4.4c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5
                c0,1.4,0.7,2.7,1.9,3.6c0.7,0.5,1.5,0.7,2.5,0.7c0.2,0,0.6,0,1-0.1c0.3,0,0.5,0.1,0.6,0.4c0,0.3-0.1,0.5-0.4,0.6
                C37.6,33.2,37.1,33.2,37,33.2z M35,35.3c0,0-0.1,0-0.1,0c-1.6-0.4-2.6-1-3.7-2.1c-1.4-1.4-2.2-3.3-2.2-5.2c0-1.6,1.4-2.9,3.1-2.9
                c1.7,0,3.1,1.3,3.1,2.9c0,1.1,0.9,1.9,2.1,1.9c1.2,0,2.1-0.9,2.1-1.9c0-3.8-3.2-6.8-7.2-6.8c-2.8,0-5.4,1.6-6.6,4
                c-0.4,0.8-0.6,1.8-0.6,2.8c0,0.8,0.1,2,0.7,3.6c0.1,0.3,0,0.6-0.3,0.6c-0.3,0.1-0.6,0-0.6-0.3c-0.5-1.3-0.7-2.6-0.7-4
                c0-1.2,0.2-2.3,0.7-3.2c1.3-2.8,4.3-4.6,7.5-4.6c4.5,0,8.2,3.5,8.2,7.8c0,1.6-1.4,2.9-3.1,2.9s-3.1-1.3-3.1-2.9
                c0-1.1-0.9-1.9-2.1-1.9c-1.1,0-2.1,0.9-2.1,1.9c0,1.7,0.7,3.3,1.9,4.5c1,0.9,1.9,1.5,3.3,1.8c0.3,0.1,0.4,0.4,0.3,0.6
                C35.4,35.1,35.2,35.3,35,35.3z"/>
        </svg>
    )
}

export default UserIcon


// WEBPACK FOOTER //
// ./src/components/practice_admin/images/UserIcon.jsx